import React, { useEffect, useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom';
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import { Button } from '@mui/material';
import { LoaderScreen } from '../../../components/LoaderScreen';
import CreateIcon from '@mui/icons-material/Create';
import ChecklistIcon from '@mui/icons-material/PlaylistAddCheck';
import { ButtonBack } from '../Util/ButtonBack';
import AddIcon from '@mui/icons-material/Add';
import { ActividadModal } from './ActividadModal';

const getTiempo = (tiempo) => {
    switch (tiempo) {
        case "D":
            return "DIAS";
        case "H":
            return "HORAS";
        case "M":
            return "MINUTOS";
        default:
            return tiempo;
    }
};

const getPrioridadInfo = (prioridad) => {
    switch (prioridad) {
        case "A":
            return { label: "ALTA", clase: "status-badge--prioridad-alta" };
        case "M":
            return { label: "MEDIANA", clase: "status-badge--prioridad-media" };
        case "B":
            return { label: "BAJA", clase: "status-badge--prioridad-baja" };
        default:
            return null;
    }
};

export const CatalogoActividadesScreen = () => {

    const history = useHistory();
    const [data, setData] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [recurrentes, setRecurrentes] = useState({});
    const [modal, setModal] = useState({ open: false, editId: null });
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const cargarListado = useCallback(() => {
        setLoader((prev) => ({ ...prev, mostrar: true }));

        request
            .get(`Actividad/Listado`)
            .then((result) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                const ordenado = result.sort((a, b) => a.idactividad - b.idactividad);
                setData(ordenado);
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("LISTADO ACTIVIDADES", JSON.stringify(error), "error");
            });
    }, []);

    // Marcador "RECURRENTE" por actividad -- si falla o no hay nada
    // configurado todavía, simplemente no se muestra ningún badge (no
    // afecta el listado principal de arriba).
    const cargarRecurrentes = useCallback(() => {
        request
            .get("Actividad/ListadoRecurrencia")
            .then((result) => {
                const data = result?.data ?? result ?? [];
                const mapa = {};
                (data || []).forEach((r) => {
                    mapa[r.idActividad] = !!r.esRecurrente;
                });
                setRecurrentes(mapa);
            })
            .catch(() => { });
    }, []);

    useEffect(() => {
        cargarListado();
        cargarRecurrentes();
        request
            .get("GrupoActividades/Listado")
            .then((result) => setGrupos(result))
            .catch(() => {
                Swal.fire("ERROR", "No se pudieron cargar los grupos", "error");
            });
    }, [cargarListado, cargarRecurrentes]);

    const onAgregar = () => setModal({ open: true, editId: null });
    const onEditar = (id) => setModal({ open: true, editId: id });
    const onCerrarModal = () => setModal({ open: false, editId: null });
    const onChecklist = (id) => history.push(`/Permisos/CatActividadSubActividades/${id}`);
    const onModalGuardado = () => {
        cargarListado();
        cargarRecurrentes();
    };

    return (
        <PlantillaScreen
            titulo={"CATALOGO DE ACTIVIDADES"}
            className_main={1}
            className={"seguimiento-actividades-contenedor"}
        >
            <LoaderScreen loader={loader} />

            <div className='sac-contenido'>
                <div className='sacc-agregar'>
                    <Button
                        variant="contained"
                        onClick={onAgregar}
                    >
                        <AddIcon />
                        Agregar
                    </Button>
                </div>

                <div className='sacc-tabla sacc-tabla-act scroll'>

                    <table className='sacct-container'>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>GRUPO</th>
                                <th>NOMBRE</th>
                                <th>PRIORIDAD</th>
                                <th>SLA</th>
                                <th>TIEMPO SOLUCIÓN</th>
                                <th>TIPO TIEMPO</th>
                                <th>ESTADO</th>
                                <th>RECURRENTE</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((menu) => {
                                const prioridad = getPrioridadInfo(menu.prioridad);
                                const esRecurrente = !!recurrentes[menu.idactividad];
                                return (
                                    <tr key={menu.idactividad}>
                                        <td><span className="sacct-id-chip">{menu.idactividad}</span></td>
                                        <td>{menu.nombregrupoactividades}</td>
                                        <td>{menu.nombreactividad}</td>
                                        <td>
                                            {prioridad ? (
                                                <span className={`status-badge ${prioridad.clase}`}>
                                                    {prioridad.label}
                                                </span>
                                            ) : "-"}
                                        </td>
                                        <td>{menu.sla}</td>
                                        <td>{menu.tiemposolucion}</td>
                                        <td>{getTiempo(menu.tiempo)}</td>
                                        <td>
                                            <span className={`status-badge ${menu.estado ? "status-badge--activo" : "status-badge--inactivo"}`}>
                                                {menu.estado ? "ACTIVO" : "INACTIVO"}
                                            </span>
                                        </td>
                                        <td>
                                            {esRecurrente ? (
                                                <span className="status-badge status-badge--activo">SÍ</span>
                                            ) : "-"}
                                        </td>
                                        <td className='sa-editar'>
                                            <ChecklistIcon
                                                style={{ cursor: "pointer", color: "#367c2b", marginRight: 10 }}
                                                titleAccess="Configurar checklist"
                                                onClick={() => onChecklist(menu.idactividad)}
                                            />
                                            <CreateIcon
                                                style={{ cursor: "pointer", color: "#ed7d31" }}
                                                onClick={() => onEditar(menu.idactividad)}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            <ActividadModal
                open={modal.open}
                editId={modal.editId}
                grupos={grupos}
                onClose={onCerrarModal}
                onSaved={onModalGuardado}
            />

            <ButtonBack path={'/Permisos/Main'} ></ButtonBack>
        </PlantillaScreen>
    );
}
